import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { style: { borderBottom: '1px solid #E9E9E9' } }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "请选择需要导出的字段：", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.showModal,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showModal) = $event)),
    title: "导出客服",
    okText: "导出",
    cancelText: "取消",
    onOk: _ctx.handleOk
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_a_checkbox, {
            checked: _ctx.checkAll,
            "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkAll) = $event)),
            indeterminate: _ctx.indeterminate,
            onChange: _ctx.onCheckAllChange
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["checked", "indeterminate", "onChange"])
        ]),
        _hoisted_5,
        _createVNode(_component_a_checkbox_group, {
          value: _ctx.checkedList,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkedList) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
                  return (_openBlock(), _createBlock(_component_a_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_checkbox, { value: index }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(option), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    ]),
                    _: 2
                  }, 1024))
                }), 256))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onOk"]))
}